import * as React from "react";
import PropTypes from 'prop-types';

const SvgYdtSort = props => {
  if (props.id !== "_svgydtsort") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M9.52 23.8L9 23.3l-.09-.1-4.71-4.85a.71.71 0 010-1l.48-.49a.68.68 0 011 0L9 20.33V9a1 1 0 012 0v11.36l3.4-3.47a.668.668 0 011 0l.48.49a.71.71 0 010 1l-5.4 5.42a.668.668 0 01-1 0M22.49 8.2l.51.5.09.1 4.71 4.85a.69.69 0 010 1l-.48.5a.68.68 0 01-1 0L23 11.66v11.39a1 1 0 01-1.91 0v-11.4l-3.44 3.46a.668.668 0 01-1 0l-.48-.49a.71.71 0 010-1l5.35-5.42a.68.68 0 011 0" /></svg>;
};

SvgYdtSort.displayName = "_svgydtsort";
SvgYdtSort.propTypes = {
  id: PropTypes.string
};
SvgYdtSort.defaultProps = {
  id: ''
};
export default SvgYdtSort;